// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"sv_a bhm_b bhm_bj","StrollerbaseBanner__hint":"sv_b bhm_vh","StrollerbaseBanner__link":"sv_c"};